import { Fragment, h } from 'preact'
import { signal } from '@preact/signals'
import { getElcoConf } from '../../js/modules/getElcoConf.js'
import { SG1Logs } from '../../js/modules/logs.js'

export const metaDataState = signal('')

var isMetatadaDone = false

export const Metadata = ({ SEO, partners, technical, sections, idzoneVector }) => {
   try {
      //HeadSections
      let headSections = []
      if (metaDataState.value !== '' && metaDataState.value['headSections'] !== undefined) {
         headSections = metaDataState.value['headSections'].headSections
         if (headSections.length > 0) {
            // Création du header masqué qui contiendra les sections
            const headerElement = document.createElement('header')
            headerElement.id = 'headSections'
            document.body.insertAdjacentElement('afterbegin', headerElement)
            // Ajout des sections dans le header masqué
            for (const section of headSections) {
               const headSectionElement = document.createElement('section')
               headSectionElement.id = section
               headerElement.appendChild(headSectionElement)
            }
         }
      }

      // Medatada
      if (isMetatadaDone === false) {
         isMetatadaDone = true

         // idzone
         window.o_idzone = idzoneVector

         // Body classes & ID
         document.body.id = getPageId(technical.pageId)
         if (technical.isUserLogged === true) document.body.classList.add('is-logged')
         document.body.classList.add(`is-${technical.deviceType}`)

         // Page Testid
         const testid = `${technical.pageId}`
         document.body.setAttribute('data-testid', testid)

         // Page sections et H1
         const mainElement = document.getElementById('sg1-sections')
         if (mainElement !== null) {
            // H1 pour les HP
            if (getPageId(technical.pageId).startsWith('hp')) {
               const h1Element = document.createElement('h1')
               h1Element.textContent = 'Accueil du site Orange'
               h1Element.classList.add('sr-only')
               mainElement.appendChild(h1Element)
            }
            // sections
            for (const section of sections) {
               const sectionElement = document.createElement('section')
               sectionElement.id = section
               mainElement.appendChild(sectionElement)
            }
         }

         // dataLayer
         addDatalayer(getPageId(technical.pageId), technical.isUserLogged, technical.deviceType, technical.idTracking, technical.experimentVariant)

         // Add PDB
         const pdbLoaded = () => {
            const pdbConfig = {
               prefix: 'adv',
               watchedAttributes: ['canal', 'cappingdata'],
               pixelURL: technical.adviseCappingURL,
               method: 'POST',
               plugin: 'adviseCapping',
            }
            try {
               if (window.dataStoreHP.SSEstatus === 'disconnected') {
                  o_pdb.init(pdbConfig)
               } else {
                  document.addEventListener('sseEndOfTransmition', () => {
                     o_pdb.init(pdbConfig)
                  })
               }
            } catch (error) {
               console.error('Pdb capping error')
            }
         }

         // Add ELCO
         const elcoLoaded = () => {
            // WORKAROUND : Trigger le DOMContentLoaded pour déclencher le header des elcos
            window.document.dispatchEvent(
               new Event('DOMContentLoaded', {
                  bubbles: true,
                  cancelable: true,
               })
            )

            if (typeof head !== 'undefined') {
               head.ready(function () {
                  if ((technical.userconsent?.c1 === true)
                     && (technical.userconsent?.c2 === true)
                     && !technical.featureFlags.ff_disable_pdb
                  ) {
                     // il faut avoir les elco pour executer le capping advise
                     addScript('', '', 'https://gp.cdn.woopic.com/tools/pdb.min.js', pdbLoaded)
                  }

                  o_footer()

                  if (technical.pageId === 'prospect-nl') {
                     const isSearchFormReady = document.getElementById('searchForm') !== null ? true : false
                     if (isSearchFormReady) {
                        o_generateSearchZone('searchForm', 'hp')
                     } else {
                        document.addEventListener(
                           'generateSearchZone',
                           (event) => {
                              o_generateSearchZone('searchForm', 'hp')
                           },
                           { once: true }
                        )
                     }
                  }
               })
            }
         }

         if (!technical.featureFlags.pf_disable_partners) {
            addElcoConf(technical.pageId, technical.appEnv)
            addScript('', '', 'https://c.woopic.com/libs/common/o_load_responsive.js', elcoLoaded)
         }

         // Add AdGateway
         if (partners.adGatewayURL !== '' && !technical.featureFlags.pf_disable_partners) {
            // On attend que tous les id pub soient posés pour déclencher le tag adgateway
            document.addEventListener('sseEndOfTransmition', () => {
               let tag = document.createElement('script')
               tag.src = partners.adGatewayURL
               tag.defer = true
               tag.dataset.testid = 'script-pub'
               document.head.appendChild(tag)
            })
         }

        // Add sentry
        if (technical.featureFlags.ff_sentry) {
            let sampleRate = 0.01;
            if(technical.appEnv === 'dev' || technical.appEnv === 'staging'){
                sampleRate = 1.0; // 100% en dev et staging
            }
            let sentryTag = document.createElement('script');
            sentryTag.src = 'https://browser.sentry-cdn.com/10.8.0/bundle.min.js';
            sentryTag.integrity = 'sha384-OeXjkPMDAnxIgoEIBDnXWKhce+ctYZHJjn+VcfoEzUIV/YPFgf5sPIMT6Fr68nfq';
            sentryTag.crossOrigin = 'anonymous'
            sentryTag.onload = ()=>{
                Sentry.init({
                    dsn: "https://30c8b7449a3d3dccbcfcf31a9635a42f@sentry.si.fr.intraorange/5",
                    sampleRate: sampleRate,
                    environment: technical.appEnv,
                });
            }
            document.head.appendChild(sentryTag)
        }
    }
   } catch (error) {
      console.error('metadata orchestrator', error)
      SG1Logs.incLog('Err_CORCH')
   }

   return (
      <Fragment>
         <title>{SEO.title}</title>
         <meta name="description" content={SEO.description} />
         <meta name="robots" content="index, follow" />
         <link href={SEO.canonicalURL} rel="canonical" />
         {partners.facebooksiteverif && <meta name="facebook-domain-verification" content={partners.facebooksiteverif} />}
         {partners.googlesiteverif && <meta name="google-site-verification" content={partners.googlesiteverif} />}
         <script type="application/ld+json">{SEO.jsonLD}</script>
         {technical.featureFlags.pf_cyclope && <script src="https://artifactory.si.francetelecom.fr/mfy-ftaccueilv-generic/cyclope/cyclope.user.js" />}
      </Fragment>
   )
}

const addScript = (type = '', content = '', src = '', callback) => {
   let tag = document.createElement('script')
   src !== '' ? (tag.src = src) : ''
   type !== '' ? (tag.type = type) : ''
   content !== '' ? (tag.textContent = content) : ''
   typeof callback === 'function' ? (tag.onload = callback) : ''
   document.head.appendChild(tag)
}

const getPageId = (refZ) => {
   const listPageId = {
      hp: ['hp', 'hp-nl', 'hp-mob', 'hp-mob-nl'],
      'hp-regulier': ['regulier', 'regulier-nl', 'regulier-mob', 'regulier-mob-nl'],
      'hp-occasionnel': ['occas', 'occas-nl', 'occas-mob', 'occas-mob-nl'],
      'hp-prospect': ['prospect-nl', 'prospect-mob-nl'],
      'vitrine-boutique': ['boutique-nl', 'boutique-mob-nl'],
      'vitrine-boutique-client': ['boutique', 'boutique-mob'],
      'n1-tv-prospect': ['divert-prospect-nl', 'divert-prospect-mob-nl', 'divert-prospect', 'divert-prospect-mob'],
      'n1-tv': ['divert-client-nl', 'divert-client-mob-nl', 'divert-client', 'divert-client-mob'],
   }

   for (let key in listPageId) {
      if (listPageId[key].includes(refZ)) {
         return key
      }
   }
}

const addDatalayer = (pageId, isUserLogged, deviceType, idTracking, experimentVariant) => {
   switch (pageId) {
      case 'hp': // version aloha
         window.o_data = {
            domaine: 'Portail',
            titre_page: 'hp',
            type_page: 'hp',
            univers_affichage: 'global',
         }
         break
      case 'hp-regulier':
         window.o_data = {
            domaine: 'Portail',
            titre_page: 'hp_regulier',
            type_page: 'hp',
            univers_affichage: 'global',
         }
         break
      case 'hp-occasionnel':
         window.o_data = {
            domaine: 'Portail',
            titre_page: 'hp_occasionnel',
            type_page: 'hp',
            univers_affichage: 'global',
         }
         break
      case 'hp-prospect':
         window.o_data = {
            domaine: 'Portail',
            titre_page: 'hp_prospect',
            type_page: 'hp',
            univers_affichage: 'global',
         }
         break

      case 'vitrine-boutique':
      case 'vitrine-boutique-client':
         window.o_data = {
            domaine: 'Shop',
            titre_page: 'hp_boutique',
            type_page: 'hp',
            univers_affichage: 'global',
         }
         break

      case 'n1-tv-prospect':
         window.o_data = {
            domaine: 'Shop',
            titre_page: 'cremaillere_divertissement_prospect-tv',
            type_page: 'cremaillere',
            univers_affichage: 'tv',
         }
         break
      case 'n1-tv':
         window.o_data = {
            domaine: 'Shop',
            titre_page: 'cremaillere_divertissement_client-tv',
            type_page: 'cremaillere',
            univers_affichage: 'tv',
         }
         break
   }
   window.o_data.id_tracking = idTracking
   window.o_data.segment = 'RES'
   window.o_data.sous_univers = 'global'
   window.o_data.canal = deviceType === 'mobile' ? 'Mobile Web' : 'Web'

   deviceType === 'mobile' ? (window.o_data.titre_page += '_webapp') : ''
   isUserLogged === true ? (window.o_data.titre_page += '_logue') : (window.o_data.titre_page += '_non_logue')

   // Abtests
   // ajoute le variant choisi par l'API pour l'abtest qui a été choisi
   if (experimentVariant && experimentVariant.variant) {
      window.o_data.experiment = experimentVariant.variant
   }
}

const addElcoConf = (refZ, appEnv) => {
   const listConfNameRefZ = {
      hp: ['hp'],
      'hp-nl': ['hp-nl'],
      'hp-mob': ['hp-mob'],
      'hp-mob-nl': ['hp-mob-nl'],

      regulier: ['regulier', 'regulier-nl'],
      prospect: ['prospect-nl'],
      'prospect-regulier-mob': ['regulier-mob', 'regulier-mob-nl', 'prospect-mob-nl'],
      occas: ['occas', 'occas-nl'],
      'occas-mob': ['occas-mob', 'occas-mob-nl'],
      boutique: ['boutique', 'boutique-nl'],
      'boutique-mob': ['boutique-mob', 'boutique-mob-nl'],
      divert: ['divert-prospect', 'divert-prospect-nl', 'divert-client', 'divert-client-nl'],
      'divert-mob': ['divert-prospect-mob', 'divert-prospect-mob-nl', 'divert-client-mob', 'divert-client-mob-nl'],
   }
   //methode qui retourne la clé de confg qui contient la refZ et affecte la confelco correspondante à o_confCommon
   for (let key in listConfNameRefZ) {
      if (listConfNameRefZ[key].includes(refZ)) {
         window.o_confCommon = getElcoConf(key)
         break
      }
   }

   window.o_confCommon.typeEnv = appEnv === 'dev' || appEnv === 'staging' || appEnv === 'preprod' ? 'rec' : 'prod'
   window.o_confCommon.tracking.refz.page = refZ
}
